import { render, staticRenderFns } from "./NtdInstituteCreateDialog.vue?vue&type=template&id=a8ec1522"
import script from "./NtdInstituteCreateDialog.vue?vue&type=script&lang=ts"
export * from "./NtdInstituteCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports